import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3125InitCreateDocumentNature } from "../../U3125Service";

interface U3125FactureVoidDlgProps {
  isOpen: boolean;
  onClose: (result: "yes" | "no") => void;
  invoiceLabel: string;
  documentNature: U3125InitCreateDocumentNature;
  t: TFunction;
  NS: string;
}

const VOID_MESSAGE_KEYS: Record<U3125InitCreateDocumentNature, string> = {
  STANDARD: "dlgVoidInvoiceMessage_STANDARD",
  CREDIT: "dlgVoidInvoiceMessage_CREDIT",
  ADVANCE: "dlgVoidInvoiceMessage_ADVANCE",
  WIP_WRITE_OFF: "dlgVoidInvoiceMessage_WIP_WRITE_OFF",
};

function U3125FactureVoidDlg({ isOpen, onClose, invoiceLabel, documentNature, t, NS }: U3125FactureVoidDlgProps) {
  if (!isOpen) return null;

  const messageKey = VOID_MESSAGE_KEYS[documentNature] ?? "dlgVoidInvoiceMessage_STANDARD";

  return (
    <U2000DeleteRecordDialog isOpen={isOpen} onClose={onClose} title={t("dlgVoidInvoiceTitle", { ns: NS })}>
      <p className="mb-4">{t(messageKey, { ns: NS })}</p>
      {invoiceLabel ? (
        <div className="mt-2 flex flex-wrap justify-center gap-x-2">
          <span className="inline-block text-gray-800">{invoiceLabel}</span>
        </div>
      ) : null}
    </U2000DeleteRecordDialog>
  );
}

export default U3125FactureVoidDlg;
